import { Container } from "react-bootstrap";
import { Form } from "@/ui/Form";
import { useLocale } from "@/hooks/useLocale";
import clsx from "classnames";
import classes from "./styles.module.scss";
import { DynamicText } from "@/ui/DynamicText";
import { DynamicHtml } from "@/ui/DynamicHtml";
import { useLink } from "@/hooks/useLink";
import sourceflowEnums from "@/sourceflow.enums";

export const ContactPageFormSection = ({ className }) => {
  const locale = useLocale();
  const link = useLink();

  const onSubmitDone = () => {
    if (typeof window !== "undefined") {
      window.location.href = link("contact.form.complete");
    }
  };

  return (
    <div className={className}>
      <Container className="px-0">
        <div className={clsx(classes.form, "p-4 p-md-5")}>
          <DynamicText path={`page.contact.form.title.${locale}`} tag="h4" className="mb-2" />
          <DynamicHtml path={`page.contact.form.text.${locale}`} className="mb-4" />
          <Form className="" formId={sourceflowEnums.forms.contactUs[locale]} onSubmitDone={onSubmitDone} />
        </div>
      </Container>
    </div>
  );
};
